import { Component } from 'react';
import * as React from 'react';
import { PageWrapper } from '../uiComponents/layout/PageWrapper';
import { ContentWrapper } from '../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../uiComponents/layout/SectionGroup';
import { RouteComponentProps } from 'react-router';
import { ErrorWrapper } from '../uiComponents/ErrorWrapper';
import { LinkPrimaryButton } from '../uiComponents/input/Buttons';

export interface ErrorPageProps extends RouteComponentProps<any> {
    message?: string;
}

class ErrorPage extends Component<ErrorPageProps, any> {
    render() {
        let errorMessage = decodeURIComponent(this.props.match.params.message);
        if (this.props.message !== undefined) {
            errorMessage = this.props.message;
        }

        return (
            <PageWrapper>
                <ContentWrapper>
                    <SectionGroup>
                        <ErrorWrapper header='Ups!'>
                            <b>Der er desværre sket en fejl.</b>
                            <br/>
                            <br/>
                            <p>{errorMessage}</p>
                            Telefon: <a href='tel:+4529715408'>+45 29 71 54 08</a><br />
                            Mail: <a href='mailto:kontakt@nvhus.dk'>kontakt@nvhus.dk</a><br />
                            <LinkPrimaryButton url='/logout' text='Log ud' />
                        </ErrorWrapper>
                    </SectionGroup>
                </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default ErrorPage;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/ErrorPage.tsx